import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const BudgetReports = () => {
  return (
    <>
      {/* Breadcrumb - Outside page-container to align with sidebar */}
      <PageBreadcrumb />
      {/* Page Header - Outside page-container to align with sidebar */}
      <PageHeader 
        title="Budget Reports"
        description="Comprehensive reports and analytics for budget management"
      />
      <div className="page-container" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-purple-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <FileText size={48} className="text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Budget Analytics</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Comprehensive budget reports with detailed analytics and performance insights. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced budget reporting with customizable dashboards, 
                automated report generation, and interactive analytics.
              </p>
            </div>

            <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors flex items-center mx-auto">
              <FileText size={20} className="mr-2" />
              Generate Report
            </button>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default BudgetReports;
